import { defineStore } from 'pinia'

export const useFormStore = defineStore('form', {
  state: () => ({
    productHistory: {}
  }),
  getters: {},
  actions: {
    // 记录产品名称，产品利益点
    addProductName({ product_name, benefits }) {
      const time = new Date().getTime()
      this.productHistory = this.getProductName() || {}
      this.productHistory[product_name] = { benefits, time }
      const productHistoryString = JSON.stringify(this.productHistory)
      localStorage.setItem('productHistoryString', productHistoryString)
    },
    getProductName() {
      const productHistory = JSON.parse(localStorage.getItem('productHistoryString'))
      return productHistory
    }
  }
})
